export default __webpack_public_path__ + "static/media/session-time.dae7c7bb.png";